import {
  ServiceRequestFieldType,
  ServiceRequestStep,
  ServiceRequestStepType,
} from '@domain/types';
import { t } from 'i18next';

//descriptionStep that is required
export const descriptionStep: ServiceRequestStep = {
  type: ServiceRequestStepType.DETAILS,
  inSummary: true,
  title: `quote:description.title`,
  additionalCopy: `quote:additionalCopy.description.title`,
  segmentEvent: `Additional Info Filled in`,
  fields: [
    {
      type: ServiceRequestFieldType.TEXTAREA,
      summaryTitle: `quote:description.summaryTitle`,
      props: {
        name: `questions.${t(`quote:description.summaryTitle`)}`,
        placeholder: `quote:description.placeholder`,
        validation: [`isRequired`, `minLength(10)`],
      },
    },
  ],
};
